import { render, staticRenderFns } from "./lgsOilOrderList.vue?vue&type=template&id=1b6c688a&scoped=true"
import script from "./lgsOilOrderList.vue?vue&type=script&lang=js"
export * from "./lgsOilOrderList.vue?vue&type=script&lang=js"
import style0 from "./lgsOilOrderList.vue?vue&type=style&index=0&id=1b6c688a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c688a",
  null
  
)

export default component.exports